import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { NarrowMode, ToggleSize, ToggleTheme } from "./types";
function IconContainer(attrs) {
  const { icon } = attrs;
  return /* @__PURE__ */ jsx("div", {
    sel: ".icon-container",
    attrs: { icon }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: {
      icon
    }
  }));
}
export function template() {
  const options = this.helpers.toggleOptions();
  const { narrowMode } = this.state;
  const selectedIndex = (options || []).findIndex((toggleOption) => toggleOption.value === this.attr(`selected`));
  const theme = this.attr(`theme`);
  const hideTooltip = theme === `tab-bar-heavy` && narrowMode !== NarrowMode.OnlyIcons;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-toggle",
    class: {
      "toggle-large": this.attr(`size`) === ToggleSize.Large,
      "theme-tabbar": theme === ToggleTheme.TabBar,
      "theme-tabbar-borderless": theme === ToggleTheme.TabBarBorderless,
      "theme-tabbar-lite": theme === ToggleTheme.TabBarLite,
      "theme-tabbar-heavy": theme === ToggleTheme.TabBarHeavy,
      "theme-segcon": theme === ToggleTheme.SegmentedController
    },
    hook: { insert: (vnode) => this.wrapperInserted(vnode) }
  }, options.map((toggleOption, index) => {
    const isSelected = index === selectedIndex;
    const beforeSelected = index === selectedIndex - 1;
    const { icon, iconColor, label, value, disabled, tooltip, tooltipLabel, href } = toggleOption;
    const showLabel = label.length && narrowMode !== NarrowMode.OnlyIcons;
    const hasTextAndIcon = Boolean(icon && showLabel);
    let tooltipEl = null;
    if (tooltip) {
      tooltipEl = /* @__PURE__ */ jsx(TooltipEl, {
        attrs: tooltip
      });
    } else if (tooltipLabel) {
      tooltipEl = /* @__PURE__ */ jsx(TooltipEl, {
        attrs: { placement: Placement.Top, text: tooltipLabel }
      });
    }
    return theme === `segmented-controller` ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-toggle-option",
      class: { selected: isSelected }
    }, /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".mp-toggle-button",
      attrs: {
        theme: ButtonTheme.Tertiary,
        size: this.attr(`size`),
        icon,
        disabled,
        selected: isSelected,
        "not-focusable": true,
        href
      },
      on: {
        click: () => !disabled && this.helpers.selectOption(value)
      }
    }, label), tooltipEl) : /* @__PURE__ */ jsx("a", {
      sel: ".mp-toggle-option",
      class: {
        "mp-toggle-selected": isSelected,
        "before-selected": beforeSelected,
        "mp-toggle-disabled": disabled,
        "mp-toggle-text-and-icon": hasTextAndIcon,
        "has-label": showLabel
      },
      style: {
        "--selected-toggle-icon-color": iconColor
      },
      on: {
        click: () => !disabled && this.helpers.selectOption(value),
        mouseenter: () => this.hovered(value),
        mouseleave: () => this.cancelHover()
      },
      attrs: href ? { href } : {}
    }, /* @__PURE__ */ jsx("div", {
      sel: ".container"
    }, icon ? /* @__PURE__ */ jsx(IconContainer, {
      icon
    }) : null, showLabel ? label : null), /* @__PURE__ */ jsx("div", {
      sel: ".highlight-bar"
    }), !hideTooltip && tooltipLabel ? /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { placement: Placement.Top, text: tooltipLabel }
    }) : null);
  }));
}
